import type State from './State'

export default function onClick(state: State) {
  state.setSegmentByCursor().setSelectionRangeFromSegment()
}
